export const cornerConnectionProposalEventName = 'corner-connection-proposal-custom-event'

export type CornerConnectionProposalEventData = {
  anchorGuid: string
  manualLoadField: string
  rawFormula: string
  maxForce: number
  value?: string
}

export type CornerConnectionProposalEvent = CustomEvent<CornerConnectionProposalEventData>

function subscribeCornerConnectionProposalEvent(
  handler: (event: CornerConnectionProposalEvent) => void,
) {
  document.addEventListener(cornerConnectionProposalEventName, handler as unknown as EventListener)
}

function unsubscribeCornerConnectionProposalEvent(
  handler: (event: CornerConnectionProposalEvent) => void,
) {
  document.removeEventListener(
    cornerConnectionProposalEventName,
    handler as unknown as EventListener,
  )
}

function publishCornerConnectionProposalEvent(data: CornerConnectionProposalEventData) {
  const event = new CustomEvent<CornerConnectionProposalEventData>(
    cornerConnectionProposalEventName,
    {
      detail: data,
    },
  )
  document.dispatchEvent(event)
}

export {
  publishCornerConnectionProposalEvent,
  subscribeCornerConnectionProposalEvent,
  unsubscribeCornerConnectionProposalEvent,
}
